import React from 'react'
import { Box, Typography } from '@mui/material'
import Icon from "../Icon/Icon";
import { useNavigate } from "react-router-dom";

const PayRecord = ({ paymentData }) => {
    const navigate = useNavigate();
    const getEncodedQuery = (data) => {
        const ascii = encodeURIComponent(JSON.stringify({
            title: data.entryNameLabel,
            startDate: data.transactionStartDate,
            endDate: data.transactionEndDate,
        }))
        const array = new TextEncoder().encode(ascii)
        const zip = window.fflate.deflateSync(array, { level: 9 })
        return encodeURIComponent(window.btoa(String.fromCharCode(...zip)))
    }

    return (
        <>
            <Box width={"100%"} maxWidth={"360px"} margin={"0 auto"} padding={"20px 0"}>
                {
                    paymentData.map((data, key) => {
                        return (
                            <Box
                                key={key}
                                onClick={() => navigate("/transaction-history/" + getEncodedQuery(data))}
                                display={"flex"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                                padding={"16px 0px"}
                                borderBottom={"1px solid #EAEAEA"}
                                sx={{ cursor: "pointer" }}
                            >
                                <Typography fontSize={16} fontWeight={700} color={"#43474E"} component="span">{data.entryNameLabel}</Typography>
                                <Icon name="next" />
                            </Box>
                        )
                    })

                }
            </Box>
        </>
    )
}

export default PayRecord